export class Modelogoogle {
  id?: string;
  name: string = "";
  redirect?: string;
  descripcion: string = "";
  titulodeldocumento: string = "";
  cicloid: number = 0;

  constructor(init?: Partial<Modelogoogle>) {
      Object.assign(this, init);
  }
}
